import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./adminNav.css";

const AdminNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: "/admin", label: "Rezervace" },
    { path: "/admin/emails", label: "Emaily" },
  ];

  return (
    <div className="adminNav">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          className={`adminNavTab ${location.pathname === tab.path ? "adminNavTab--active" : ""}`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default AdminNav;
